import React from 'react'; 
import ArcAnimation from '../components/ArcAnimation';

function Logo() {


    return (
      <div className="fullDiv">
        <ArcAnimation />
      </div>
    );
  }
export default Logo;